// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import { Box } from "@mui/material"
import { BulkDeleteDialog } from "@/components/ui/bulk-delete-dialog"
import { formatCurrency } from "@crm-src/lib/utils"

interface Invoice {
  id: string | number
  invoice_number: string
  total_amount: number
  customer_company_name?: string
  customer_name?: string
  payment_status: string
}

interface BulkDeleteInvoiceModalProps {
  isOpen: boolean
  onClose: () => void
  selectedInvoices: Invoice[]
  onConfirmDelete?: (invoiceIds: string[]) => Promise<void>
  documentType?: "invoice" | "quote"
}

export function BulkDeleteInvoiceModal({
  isOpen,
  onClose,
  selectedInvoices,
  onConfirmDelete,
  documentType = "invoice",
}: BulkDeleteInvoiceModalProps) {
  const isQuote = documentType === "quote"
  const labels = isQuote
    ? { singular: "Quote", plural: "Quotes" }
    : { singular: "Invoice", plural: "Invoices" }
  const noun = documentType

  return (
    <BulkDeleteDialog
      isOpen={isOpen}
      onClose={onClose}
      items={selectedInvoices}
      entityLabel={labels}
      cascadingWarning={`This will mark all selected ${noun}s as deleted. They can be restored if needed. Associated files will be preserved.`}
      renderItem={(inv) => (
        <>
          {inv.invoice_number}
          <Box component="span" sx={{ color: "error.main" }}>
            {" "}
            — {formatCurrency(inv.total_amount)}
            {inv.customer_company_name || inv.customer_name
              ? ` — ${inv.customer_company_name || inv.customer_name}`
              : ""}
          </Box>
        </>
      )}
      onConfirm={async (ids) => {
        if (onConfirmDelete) await onConfirmDelete(ids)
      }}
    />
  )
}
